import { render, staticRenderFns } from "./gns.vue?vue&type=template&id=6b54a0c5&scoped=true"
import script from "./gns.vue?vue&type=script&lang=js"
export * from "./gns.vue?vue&type=script&lang=js"
import style0 from "./gns.vue?vue&type=style&index=0&id=6b54a0c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b54a0c5",
  null
  
)

export default component.exports